/* tm-avis : tri, filtre et pagination des avis, fenêtres (formulaire, photo), contrôle du formulaire.
   La page ne contient que les premiers avis : la liste complète est chargée au premier besoin
   (afficher plus, tri, filtre) depuis la section tm-avis-liste. */
(function () {
  if (window.tmAvisReady) return;
  window.tmAvisReady = true;

  /* Textes du script : français par défaut, anglais sur les pages /en et /en-be. */
  var EN = (document.documentElement.lang || '').slice(0, 2) === 'en';
  var T = EN
    ? { star: function (n) { return n + '-star'; }, reviews: function (n) { return n + (n === 1 ? ' review' : ' reviews'); }, more: 'Read more', less: 'Show less', photo: 'Customer photo', close: 'Close', photoBy: 'Photo shared by a customer' }
    : { star: function (n) { return n + ' étoile' + (n > 1 ? 's' : ''); }, reviews: function (n) { return n + ' avis'; }, more: 'Lire la suite', less: 'Réduire', photo: 'Photo du client', close: 'Fermer', photoBy: 'Photo partagée par un client' };

  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); }
    else d.setAttribute('open', '');
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
  }

  /* ---------- Formulaire ---------- */
  function initForm(form) {
    if (form.dataset.tmReady) return;
    form.dataset.tmReady = '1';
    var msg = function (k) { return form.querySelector('[data-tm-avf-msg="' + k + '"]'); };
    form.addEventListener('submit', function (e) {
      var ok = true;
      form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); el.removeAttribute('aria-invalid'); });
      form.querySelectorAll('[data-tm-avf-msg]').forEach(function (el) { el.hidden = true; });

      if (!form.querySelector('input[name="contact[Note]"]:checked')) { ok = false; var m = msg('note'); if (m) m.hidden = false; }
      var body = form.querySelector('[name="contact[body]"]');
      if (body && body.value.trim().length < 10) { ok = false; body.classList.add('is-invalid'); body.setAttribute('aria-invalid', 'true'); var mt = msg('texte'); if (mt) mt.hidden = false; }
      ['contact[Produit]', 'contact[name]', 'contact[email]'].forEach(function (n) {
        var el = form.querySelector('[name="' + n + '"]');
        if (!el || el.type === 'hidden') return;
        var bad = !el.value.trim() || (el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim()));
        if (bad) { ok = false; el.classList.add('is-invalid'); el.setAttribute('aria-invalid', 'true'); }
      });
      var consent = form.querySelector('[name="contact[Accord publication]"]');
      if (consent && !consent.checked) { ok = false; consent.classList.add('is-invalid'); }

      if (!ok) {
        e.preventDefault();
        var g = msg('general'); if (g) g.hidden = false;
        var first = form.querySelector('.is-invalid, [data-tm-avf-msg]:not([hidden])');
        if (first) {
          var target = first.matches('input, textarea, select') ? first : form.querySelector('input[name="contact[Note]"]');
          if (target) target.focus({ preventScroll: false });
        }
      }
    });
  }

  /* ---------- Liste d'avis ---------- */
  function initList(root) {
    if (root.dataset.tmReady) return;
    root.dataset.tmReady = '1';
    var list = root.querySelector('[data-tm-av-list]');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-tm-av-item]'));
    var step = parseInt(root.dataset.pageSize, 10) || 5;
    var shown = step;
    var filter = 0;
    var loadBtn = root.querySelector('[data-tm-av-load]');
    var sortSel = root.querySelector('[data-tm-av-sort]');
    var state = root.querySelector('[data-tm-av-filter-state]');
    var stateLabel = root.querySelector('[data-tm-av-filter-label]');
    var none = root.querySelector('[data-tm-av-none]');
    var bars = root.querySelectorAll('[data-tm-av-bar]');
    var total = parseInt(root.dataset.total, 10) || 0;
    var fullUrl = root.dataset.fullUrl;
    var full = !fullUrl || items.length >= total;
    var loading = null;
    var currentSort = 'recent';

    function ensureFull() {
      if (full) return Promise.resolve();
      if (loading) return loading;
      root.setAttribute('aria-busy', 'true');
      loading = fetch(fullUrl, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelectorAll('[data-tm-av-full] [data-tm-av-item]');
          if (fresh.length > items.length) {
            items.forEach(function (it) { it.remove(); });
            items = Array.prototype.map.call(fresh, function (it) { return document.importNode(it, true); });
            items.forEach(function (it) { list.appendChild(it); });
            sortItems(currentSort);
          }
          full = true;
        })
        .catch(function () { full = true; })
        .then(function () { root.removeAttribute('aria-busy'); });
      return loading;
    }

    function render() {
      var visible = items.filter(function (it) { return !filter || it.dataset.note === String(filter); });
      items.forEach(function (it) { it.hidden = true; });
      visible.forEach(function (it, i) { it.hidden = i >= shown; });
      if (loadBtn) loadBtn.parentNode.hidden = full ? visible.length <= shown : (!filter && total <= shown);
      if (none) none.hidden = visible.length > 0;
      if (state) state.hidden = !filter;
      if (stateLabel) stateLabel.textContent = T.star(filter) + ' (' + T.reviews(visible.length) + ')';
      bars.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.tmAvBar === String(filter))); });
      clampTexts();
    }

    function sortItems(mode) {
      currentSort = mode;
      items.sort(function (a, b) {
        var da = +a.dataset.date, db = +b.dataset.date, na = +a.dataset.note, nb = +b.dataset.note;
        var ta = +a.dataset.text, tb = +b.dataset.text;
        if (ta !== tb) return tb - ta; // les avis rédigés passent avant les notes seules
        if (mode === 'high') return nb - na || db - da;
        if (mode === 'low') return na - nb || db - da;
        if (mode === 'photos') return (+b.dataset.photos) - (+a.dataset.photos) || db - da;
        return db - da;
      });
      items.forEach(function (it) { list.appendChild(it); });
    }

    function clampTexts() {
      items.forEach(function (it) {
        if (it.hidden || it.dataset.clampDone) return;
        var t = it.querySelector('[data-tm-av-text]');
        var btn = it.querySelector('[data-tm-av-more]');
        if (!t || !btn) return;
        it.dataset.clampDone = '1';
        t.classList.add('is-clamped');
        if (t.scrollHeight - t.clientHeight > 4) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            var open = t.classList.toggle('is-clamped');
            btn.textContent = open ? T.more : T.less;
            btn.setAttribute('aria-expanded', String(!open));
          });
        } else {
          t.classList.remove('is-clamped');
        }
      });
    }

    if (loadBtn) loadBtn.addEventListener('click', function () { ensureFull().then(function () { shown += step * 2; render(); }); });
    if (sortSel) sortSel.addEventListener('change', function () { ensureFull().then(function () { sortItems(sortSel.value); shown = step; render(); }); });
    bars.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(b.dataset.tmAvBar, 10);
        ensureFull().then(function () {
          filter = filter === v ? 0 : v;
          shown = step;
          render();
          var top = root.querySelector('[data-tm-av-tools]');
          if (top && window.matchMedia('(max-width: 989px)').matches) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });
    var reset = root.querySelector('[data-tm-av-reset]');
    if (reset) reset.addEventListener('click', function () { filter = 0; shown = step; render(); });

    sortItems('recent');
    render();
  }

  /* ---------- Fenêtres ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-tm-av-open]');
    if (opener) {
      e.preventDefault();
      openDialog(document.getElementById(opener.getAttribute('data-tm-av-open')));
      return;
    }
    var closer = e.target.closest('[data-tm-av-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    var photo = e.target.closest('[data-tm-av-photo]');
    if (photo) {
      var d = document.getElementById('tm-av-photo-dialog');
      if (!d) {
        d = document.createElement('dialog');
        d.id = 'tm-av-photo-dialog';
        d.className = 'tm-av-dialog tm-av-dialog--photo';
        d.setAttribute('aria-label', T.photo);
        d.innerHTML = '<button type="button" class="tm-av-dialog__close" data-tm-av-close aria-label="' + T.close + '"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button><img alt="">';
        (photo.closest('.tm-av') || document.body).appendChild(d);
      }
      var img = d.querySelector('img');
      img.src = photo.getAttribute('data-tm-av-photo');
      img.alt = photo.getAttribute('data-alt') || T.photoBy;
      openDialog(d);
      return;
    }
    // clic sur le fond : ferme la fenêtre
    if (e.target.matches && e.target.matches('dialog.tm-av-dialog')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(e.target);
    }
  });

  /* ---------- Initialisation ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('.tm-avf').forEach(initForm);
    (scope || document).querySelectorAll('[data-tm-av]').forEach(initList);

    // Après un envoi (réussi ou en erreur), on rouvre la fenêtre du formulaire et on la montre.
    (scope || document).querySelectorAll('[data-tm-avf-state]').forEach(function (el) {
      var d = el.closest('dialog');
      if (d) openDialog(d);
      else el.scrollIntoView({ block: 'center' });
    });

    // Page « Donner un avis » : produit présélectionné par l'adresse (?produit=identifiant-du-produit)
    var params = new URLSearchParams(window.location.search);
    var wanted = params.get('produit');
    (scope || document).querySelectorAll('[data-tm-avf-product]').forEach(function (sel) {
      if (wanted) {
        var opt = sel.querySelector('option[data-handle="' + wanted.replace(/"/g, '') + '"]');
        if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
